import type { FaireProductEntity } from "../../entity_types/product";

export const p_ndbj3ryr7j: FaireProductEntity = {
  token: "p_ndbj3ryr7j",
  type: "product",
  name: "LM-CT-1001 Puffer Jacket - Light Pink",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/f37fa9f118d2f168099853ac394fc5bc4ed355ed9de0e7718bedf3cad463ba2a.jpeg",
  galleryImageUrls: [],
  priceDollars: 44.5,
  description: "This lightweight puffer jacket from Girlie Girl Originals offers cozy warmth and feminine styling ideal for light-weather wear. Designed with practical features, it provides comfortable insulation without bulk and pairs easily with casual or layered outfits. A versatile outerwear choice for a feminine wardrobe.",
  tags: [],
  msrpDollars: 89,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:19.108Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
